const getters = {
  token: state => state.user.token,
  isLogin:state=> state.user.isLogin,
  name : state => state.user.name
}
export default getters
